export class SavedSearchConfig {

    public searchId: number;
    public searchName: string;
    public searchNameOrig: string;

}





// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/1_SCE_CI_CD_SIT/src/app/shared/search/models/saved-search-config.ts